export const DEFAULT_LANG = 'en'
export const LANGS = [
  'ar',
  'de',
  'es',
  'fr',
  'en',
  'id',
  'it',
  'ja',
  'ko',
  'nl',
  'pl',
  'pt',
  'pt-br',
  'ru',
  'th',
  'tr',
  'zh',
  'vi'
] as const
